export default function ParticipantSummary() {
  return (
    <div></div>
  )
}
